module.exports = __webpack_public_path__ + "img/new-guide-01-2.431bccd3.png";